module.exports = __webpack_public_path__ + "img/33rd_anniversary_0714-A.1ecde6f4.jpg";